<ng-sidebar-container>    
    <ng-sidebar [(opened)]="opened" [mode]="sidebarMode">
        <div class="container-fluid" *ngIf="opened">
            <div class="row">
                <div class="col-12 mb-5">
                    <div class="row" style="height: 55px;">
                        <div class="col-12">
                            <img id="logo" class="img-fluid mt-4" src="../assets/img/GMC.png">
                        </div>
                        <!-- <div class="col-8 py-3">
                            <p class="m-1">Intereses moratorios</p>
                        </div> -->
                    </div>
                </div>
                <div class="col-12 my-1" *ngFor="let menuOption of menu; index as i">
                    <div class="row">
                        <div class="col-12 menu-option py-2" [ngClass]="{'menu-option-selected': menuOption.Selected}"
                            (click)="onClickMenuOption(menuOption)" data-toggle="collapse"
                            [attr.data-target]="'#menu-' + i">
                            <div class="row">
                                <div class="col-1">
                                    <i class="fa" *ngIf="menuOption.Children.length > 0"
                                        [ngClass]="[menuOption.Expanded ? 'fa-caret-down': 'fa-caret-right']"
                                        aria-hidden="true"></i>
                                </div>
                                <div class="col-3 text-right"><i class="fa fa-2x" [ngClass]="[menuOption.Icon]"
                                        aria-hidden="true"></i>
                                </div>
                                <div class="col-7">
                                    {{menuOption.Name}}
                                </div>
                            </div>
                        </div>

                        <div class="col-12 collapse" [attr.id]="'menu-' + i" *ngIf="menuOption.Children.length > 0">
                            <div class="row">
                                <div class="col-12 menu-option py-2 my-1"
                                    [ngClass]="{'submenu-option-selected': subMenu.Selected}"
                                    *ngFor="let subMenu of availableSubMenuOptions(menuOption.Children)"
                                    (click)="onClickMenuOption(subMenu, menuOption)">
                                    <div class="row">
                                        <div class="col-9 offset-3">
                                            {{subMenu.Name}}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-sidebar>
    <!-- <div ng-sidebar-content>
        <div class="container-fluid p-0" style="background-color: cadetblue;">
            <div id="router-outlet-container" class="pb-1"
                [ngClass]="{'outlet-container-padding': !opened, 'px-5': opened}">
                <button class="fa fa-bars fa-lg" (click)="opened=!opened"></button>
                <router-outlet></router-outlet>
            </div>
        </div>
    </div> -->
    <div ng-sidebar-content>
        <div class="container-fluid p-0">
            <app-header></app-header>
            <div id="router-outlet-container" class="pb-1"
                [ngClass]="{'outlet-container-padding': !opened, 'px-5': opened}">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
    <!-- <div ng-sidebar-content>
        <div class="container-fluid p-0" style="background-color: cadetblue;">
            <div id="router-outlet-container" class="pb-1"
                [ngClass]="{'outlet-container-padding': !opened, 'px-5': opened}">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div> -->

</ng-sidebar-container>


<!-- *ngIf="currentSession && opened" -->
<!-- ../assets/images/logo-zebol.svg -->
<!-- <app-footer></app-footer> -->
<!-- <app-header *ngIf="currentSession" [currentUser]="currentSession.UserName"></app-header> -->